// extracted by mini-css-extract-plugin
export default {"logout":"Logout_logout__-kYSB"};